import { IEventCollectionDataActiveTypeticketcollections, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'
import { IPerformerDataActiveTypeticketcollections, IPerformerMetadata } from 'meta/pages/v4/performer'

type Props = {
  code: string
  page: number
}

type Response = { data: IEventCollectionDataActiveTypeticketcollections, metadata: IEventCollectionMetadata }

export const getActiveTypeticketcollections = async (props: Props): Promise<Response> => {
  const { code, page } = props

  const endpoint = ApiEndpoint.v4.performer.activeTypeticketcollections(code, page)

  const { data, metadata } = await HttpRequestForApiV4.get<
    IPerformerDataActiveTypeticketcollections,
    IPerformerMetadata>(endpoint)
  
  return { data, metadata }
}
